// @flow

import { freeze } from "icepick";
import { FETCH_MESSAGES_SUCCESS, FETCH_MESSAGES_ERROR, SENT_MESSAGE } from "./actions";

import type { MessagesState } from "./types";

const initialState: MessagesState = freeze({
    all: null
});

export default (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_MESSAGES_SUCCESS:
            return freeze({
                ...state,
                all: payload
            });
        case SENT_MESSAGE:
            return freeze({
                ...state,
                all: [payload].concat(state.all)
            });
        case FETCH_MESSAGES_ERROR:
            return freeze({
                ...state,
                hasErrors: true
            });

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/state/messages/reducer.js